import { Component } from 'react';
import PreviewCard from 'automation-ui-canvas/components/test-flow/PreviewCard';
import ExtensionActionDetail from 'automation-ui-action-features/actions/extension/ExtensionActionDetail';
import { jsx as _jsx } from "react/jsx-runtime";
class ExtensionActionPreview extends Component {
  render() {
    const {
      action,
      logEvent,
      logEvent: {
        action: {
          metadata
        }
      },
      flowObjectTypeId,
      getActionOutputsForTargetActionById,
      getHeaderTitle,
      actionLabel,
      renderContentOnly
    } = this.props;
    const content = /*#__PURE__*/_jsx(ExtensionActionDetail, {
      action: action,
      actionMetadata: metadata,
      flowObjectTypeId: flowObjectTypeId,
      getActionLabelById: getHeaderTitle,
      getActionOutputsForTargetActionById: getActionOutputsForTargetActionById
    });
    if (renderContentOnly) {
      return /*#__PURE__*/_jsx("div", {
        className: "m-bottom-2",
        children: content
      });
    }
    return /*#__PURE__*/_jsx(PreviewCard, {
      theme: "marigold",
      icon: metadata.icon || 'integrations',
      header: actionLabel,
      content: content,
      timestamp: logEvent && logEvent.timestamp
    });
  }
}
export default ExtensionActionPreview;